/** Fixed allow-lists for RFP upload metadata (keep in sync with backend/rfp_metadata.py). */

export const RFP_OWNER_SES = [
  "Ricardo",
  "Wilson",
  "Camilo",
  "Agustin",
  "Ivan",
  "Nakano",
  "Martin",
  "Edwin",
];

export const RFP_COUNTRIES = [
  "Argentina",
  "Bahamas",
  "Belice",
  "Bolivia",
  "Brazil",
  "Chile",
  "Colombia",
  "Costa Rica",
  "Ecuador",
  "El Salvador",
  "Guatemala",
  "Honduras",
  "Jamaica",
  "Mexico",
  "Nicaragua",
  "Panama",
  "Paraguay",
  "Peru",
  "Puerto Rico",
  "Republica Dominicana",
  "Surinam",
  "Trinidad y Tobago",
  "Uruguay",
  "Venezuela",
];

/** Legacy jobs without country are shown as CALA (not selectable on upload). */
export const RFP_COUNTRY_LEGACY_DEFAULT = "CALA";

export const RFP_VERSIONS = ["v1", "v2", "v3", "v4", "v5"];
